import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { validateVehicle } from "util/vehicle/validate-vehicle";

export const productNotFitHelper = (product: ICompactProduct) => {
  const { enCategory, fitment, fitmentStatus } = product;
  const { tier2, tier3 } = enCategory;

  return fitmentStatus === "NO_FIT" && fitment !== "UNIVERSAL" && Boolean(tier2) && Boolean(tier3);
};

export const productFitmentColor = (product: ICompactProduct, selectedVehicle: any) => {
  const { fitmentStatus, fitment } = product;
  if (fitmentStatus === "GUARANTEED_FIT" || fitment === VEHICLE_FITMENT.UNIVERSAL) {
    return "success_fit_class";
  }
  if (!validateVehicle(selectedVehicle)) {
    return "partial_fit_class";
  }

  if (fitmentStatus === "POSSIBLE_FIT") {
    return "partial_fit_class";
  }
  return "no_fit_class";
};
